import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { countries, devConfig, profile } from 'config/config'; // Importing configuration data

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true, // Read-only field
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the input
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true, // Returns date as a string
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date is today
                                },
                            },
                        },
                        {
                            view: 'text', // Text input for user ID
                            minWidth: 200,
                            name: 'UserId',
                            type: 'number', // Input type is number
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'),
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Visibility based on permissions
                            ),
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'),
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            minWidth: 200,
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Custom template for displaying country flags
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Visibility based on permissions
                                ),
                            css: 'prm-filterByCountry' || true,
                        },
                        {
                            view: 'richselect', // Dropdown for commission payment type
                            name: 'ComissionsPayment',
                            label: _('Pago de comisiones'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: 'S', // Default value
                            options: [
                                { id: 'S', value: _('Saldo') }, // Option for balance
                                { id: 'F', value: _('Factura') }, // Option for invoice
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for commission type
                            name: 'ComissionsType',
                            label: _('Tipo de comisión'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: 'ALL', // Default value
                            options: [
                                { id: 'ALL', value: _('Todos') }, // Option for all types
                                { id: 'SPORTNGRAFF', value: _('SPORTNGRAFF') },
                                { id: 'DEPOSITOAFF', value: _('DEPOSITOAFF') },
                                { id: 'SPORTPVIP', value: _('SPORTPVIP') },
                                { id: 'SPORTPV', value: _('SPORTPV') },
                                { id: 'DEPOSITOPV', value: _('DEPOSITOPV') },
                                { id: 'BETSPORTPV', value: _('BETSPORTPV') },
                                { id: 'RETIROSPV', value: _('RETIROSPV') },
                                { id: 'SPORTAFF', value: _('SPORTAFF') },
                                {
                                    id: 'CASINONGRAFF',
                                    value: _('CASINONGRAFF'),
                                },
                                {
                                    id: 'DEPOSITOPVXTR',
                                    value: _('DEPOSITOPVXTR'),
                                },
                                { id: 'BETSPORTAFF', value: _('BETSPORTAFF') },
                                { id: 'WINSPORTAFF', value: _('WINSPORTAFF') },
                                { id: 'CASINOAFF', value: _('CASINOAFF') },
                                { id: 'WINSPORTPV', value: _('WINSPORTPV') },
                                { id: 'CASINOPV', value: _('CASINOPV') },
                            ],
                        },
                        {
                            view: 'richselect', // Dropdown for user type
                            name: 'UserType',
                            label: _('Tipo de usuario'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: 'ALL', // Default value
                            options: [
                                { id: 'ALL', value: _('Todos') }, // Option for all user types
                                { id: 'AF', value: _('Afiliador') },
                                { id: 'CO', value: _('Concesionario') },
                                { id: 'SC', value: _('Subconcesionario') },
                                { id: 'PV', value: _('Punto de Venta') },
                            ],
                        },
                        {
                            view: 'text', // Text input for concessionaire ID
                            minWidth: 200,
                            name: 'ConcessionaireId',
                            type: 'text',
                            labelPosition: 'top',
                            label: _('ID Concesionario'),
                            placeholder: _('ID Concesionario'),
                        },
                        {
                            view: 'checkbox', // Checkbox for summary view
                            label: _('Visualización resumida'),
                            labelPosition: 'top',
                            name: 'Type',
                            id: 'Type',
                            value: 0, // Default value
                            minWidth: 200,
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Placeholder for layout
                        {
                            view: 'button', // Button to clear filters
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                                $$('Type').setValue(0); // Reset checkbox
                                $$('NegativeBalances').setValue(1); // Reset another field
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter data
                            value: _('Consultar'),
                            hotkey: 'enter', // Enter key to trigger
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker if applicable
                                    }
                                }
                                this.app.callEvent('report:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('b5').collapse(); // Collapse the filter section
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            rows: [
                {
                    padding: 10,
                    cols: [
                        {
                            view: 'button', // Button to clear second form
                            value: _('Limpiar'),
                            click: () => {
                                $$('myForm2').clear(); // Clear the second form
                                $$('Type').setValue(0); // Reset checkbox
                                $$('NegativeBalances').setValue(1); // Reset another field
                            },
                        },
                        {
                            view: 'button', // Button to consult/filter data in second form
                            value: _('Consultar'),
                            hotkey: 'enter', // Enter key to trigger
                            type: 'form',
                            click: () => {
                                const filterdata = $$('myForm2').getValues(); // Get values from second form
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove date if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove datepicker if applicable
                                    }
                                }
                                this.app.callEvent('report:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section for filters
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the popup
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // ID for the second form
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if not applicable
                $$('Datepicker').show(); // Show datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show date input
                    $$('Datepicker').hide(); // Hide datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
